import { environment } from 'environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const cdkOutput = environment.cdkOutput;

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

document.head.insertAdjacentHTML(
  'beforeend',
  `<link rel="preconnect" href="https://${cdkOutput.FrontendStack.CloudFormationDomain}"/>`,
);
